import { Line } from 'vue-chartjs'
import moment from 'moment'

export default {
  extends: Line,

  props: {
    visits: {
      type: Array,
      default: () => []
    },
    uniqueVisits: {
      type: Array,
      default: () => []
    },
    selectedFrequency: {
      type: Object,
      default: () => {}
    }
  },

  data () {
    return {
      chartData: {
        labels: [],
        datasets: []
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            ticks: {
              min: 0,
              max: 10,
              stepSize: 1,
              reverse: false,
              beginAtZero: true
            }
          }],
          xAxes: [{
            ticks: {
              minRotation: 40
            }
          }]
        },
        legend: {
          position: 'bottom'
        },
        height: 200
      }
    }
  },

  mounted () {
    this.getChartData()
  },

  methods: {
    async getChartData () {
      this.chartData.labels = await this.parseChartLabels()
      this.chartData.datasets = [
        {
          label: 'Visits',
          borderColor: '#404040',
          data: this.parseVisitData(this.visits)
        }, {
          label: 'Unique Visits',
          borderColor: '#b00101',
          data: this.parseVisitData(this.uniqueVisits)
        }
      ]
      this.renderChart(this.chartData, this.options)
    },

    async parseChartLabels () {
      return new Promise((resolve, reject) => {
        try {
          const chartLabels = []
          let startDate = this.selectedFrequency.dateFrom
          const endDate = this.selectedFrequency.dateTo

          if (this.selectedFrequency.mode === 'hourly') {
            for (var i = 0; i < 24; i++) {
              let timeHr = i
              if (i < 10) {
                timeHr = '0' + i
              }
              chartLabels.push(timeHr + ':00')
            }
          } else if (this.selectedFrequency.mode === 'monthly') {
            while (endDate > startDate || moment(startDate).format('M') === moment(endDate).format('M')) {
              chartLabels.push(moment(startDate).format('MMM YY'))
              startDate = moment(startDate).add(1, 'months').format('YYYY-MM-DD')
            }
          } else {
            while (startDate <= endDate) {
              chartLabels.push(moment(startDate).format('MMM DD'))
              startDate = moment(startDate).add(1, 'days').format('YYYY-MM-DD')
            }
          }

          resolve(chartLabels)
        } catch (error) {
          reject(error)
        }
      })
    },

    parseVisitData (rawData) {
      const xAxis = this.chartData.labels

      const preDefinedSeriesData = []
      preDefinedSeriesData.length = xAxis.length
      const visitData = preDefinedSeriesData.fill(0)

      rawData.map(raw => {
        const d = moment(raw.timestamp).format('YYYY-MM-DD')

        if (moment(d).isSameOrAfter(this.selectedFrequency.dateFrom, 'day') && moment(d).isSameOrBefore(this.selectedFrequency.dateTo, 'day')) {
          let rawDate = moment(raw.timestamp).format('MMM DD')
          if (this.selectedFrequency.mode === 'monthly') {
            rawDate = moment(raw.timestamp).format('MMM YY')
          } else if (this.selectedFrequency.mode === 'hourly') {
            rawDate = moment(raw.timestamp).format('HH:00')
          }

          const rawIndex = this.chartData.labels.indexOf(rawDate)
          if (rawIndex > -1) visitData[rawIndex] += 1
        }
      })

      const maxVal = Math.max.apply(null, visitData)
      this.options.scales.yAxes[0].ticks.max = (maxVal > this.options.scales.yAxes[0].ticks.max) ? maxVal : this.options.scales.yAxes[0].ticks.max

      return visitData
    }
  }
}
